import { graphql } from '@/generated/gql';

export const NEGOTIATED_QUOTE_ACCEPT_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiatedQuoteAccept($negotiationCaseId: UUID!, $data: TsrctNegotiatedQuoteActionInput!) {
    tesseract {
      negotiationCase(id: $negotiationCaseId) {
        negotiatedQuote {
          draftAccept(data: $data) {
            id
          }
        }
      }
    }
  }
`);
